import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { Company } from '../models/company';
import { LoggerService } from '../../../services/logger/logger.service';
import { CompanyInfoService } from './company-info.service';
import { CompanyWorkingHours } from '../models/company-working-hours';
import { LocalizationService } from '../../../services/localization.service';
import { ShopSettingsService } from '../../general/services/shop-settings.service';
import { GlobalSettings } from 'src/environments/global-settings';

@Injectable()
export class CompanyInfoStateService {

  private _companyInfo: Company;
  private _companySchedule: CompanyWorkingHours[];
  private _todayWorkingHours: CompanyWorkingHours;

  constructor(
    private logger: LoggerService,
    private companyInfoService: CompanyInfoService,
    private localizationService: LocalizationService,
    private shopSettingsService: ShopSettingsService,
  ) { }

  get companyInfo(): Company {
    return this._companyInfo;
  }

  get companySchedule(): CompanyWorkingHours[] {
    return this._companySchedule;
  }

  get todayWorkingHours(): CompanyWorkingHours {
    return this._todayWorkingHours;
  }

  initialize(): Observable<boolean> {
    return Observable.create(
      (observable: Subscriber<boolean>) => {

        this.logger.info('CompanyInfoStateService: initialize.');

        if (!this._companyInfo && this.shopSettingsService.isWebshopMode) {

          this.logger.info('CompanyInfoStateService: initialize receiving company info.');

          this.companyInfoService.getCompanyInfo().subscribe(
            company => {
              this.logger.info('CompanyInfoStateService: initialize company info received.');
              this._companyInfo = company ? company : null;
              observable.next(true);
            },
            error => {
              this.logger.info(`CompanyInfoStateService: initialize company info receive error ${error}.`);
              observable.error(error);
            },
            () => {
              // observable.complete();
            }
          );
        } else {
          observable.next(true);
        }
      }
    );
  }

  initializeCompanySchedule(): Observable<boolean> {
    return Observable.create(
      (observable: Subscriber<boolean>) => {

        this.logger.info('CompanyInfoStateService: initialize.');

        if (!this._companySchedule) {

          this.logger.info('CompanyInfoStateService: initialize receiving company schedule.');

          this.companyInfoService.getSchedule().subscribe(
            schedule => {
              this.logger.info('CompanyInfoStateService: initialize company schedule received.');
              const currentIndexDayOfWeek = GlobalSettings.DateNow.getDay();
              if (schedule) {
                schedule = schedule.sort((a, b) => this.localizationService.compareDaysOfWeek(a.indexDayOfWeek, b.indexDayOfWeek));
                this._companySchedule = schedule;
              } else {
                this._companySchedule = null;
              }
              observable.next(true);
            },
            error => {
              this.logger.info(`CompanyInfoStateService: initialize company schedule receive error ${error}.`);
              observable.error(error);
            },
            () => {
              // observable.complete();
            }
          );
        } else {
          observable.next(true);
        }
      }
    );
  }

  initializeTodayWorkingHours(): Observable<boolean> {
    return Observable.create(
      (observable: Subscriber<boolean>) => {

        this.logger.info('CompanyInfoStateService: initialize.');

        if (!this._companyInfo) {

          this.logger.info('CompanyInfoStateService: initialize receiving company working hours.');

          this.companyInfoService.getTodayWorkingHours().subscribe(
            workingHours => {
              this.logger.info('CompanyInfoStateService: initialize company working hours received.');
              this._todayWorkingHours = workingHours ? workingHours : null;
              observable.next(true);
            },
            error => {
              this.logger.info(`CompanyInfoStateService: initialize company working hours receive error ${error}.`);
              observable.error(error);
            },
            () => {
              // observable.complete();
            }
          );
        } else {
          observable.next(true);
        }
      }
    );
  }
}
